/**
 * Created by Ning Jiang on 3/10/2020.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomWiggle.js");
import {Button, ButtonState} from "@nolimitcity/slot-game/bin/core/component/Button";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {Emitter} from "pixi-particles";

export class PickButton extends Button {

    private readonly _idleConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0
        },
        "scale" : {
            "start" : 1,
            "end" : 1.5,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"

        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -300
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 80
        },
        "lifetime" : {
            "min" : 1,
            "max" : 2
        },
        "blendMode" : "add",
        "frequency" : 0.1,
        "emitterLifetime" : 0.4,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -50,
            "y" : 0,
            "w" : 100,
            "h" : 0
        }
    };

    private readonly _overConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0
        },
        "scale" : {
            "start" : 1,
            "end" : 1.5,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"

        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -400
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 80
        },
        "lifetime" : {
            "min" : 1,
            "max" : 2
        },
        "blendMode" : "add",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -50,
            "y" : 0,
            "w" : 100,
            "h" : 0
        }
    };

    private readonly _clickConfig:any = {
        "alpha" : {
            "start" : 0.8,
            "end" : 0
        },
        "scale" : {
            "start" : 1,
            "end" : 1.2,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"

        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 0,
            "y" : -400
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 80
        },
        "lifetime" : {
            "min" : 1,
            "max" : 2
        },
        "blendMode" : "add",
        "frequency" : 0.02,
        "emitterLifetime" : 0.4,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : true,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -50,
            "y" : 0,
            "w" : 100,
            "h" : 0
        }
    };

    private readonly _numberTextStyle:any = {
        fontName : "FreespinNumber",
        fontSize : 9,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    private _glows:PIXI.Sprite[];
    private _shootOut:PIXI.Sprite;
    private _fsNumber:PIXI.BitmapText;
    private _particleContainer:PIXI.Container;
    private _idleEmitter:Emitter;
    private _isIdleEmitting:boolean;
    private _overEmitter:Emitter;
    private _clickEmitter:Emitter;

    private _keyword:string;
    private _isFloating:boolean;
    private _floatTween:TweenLite;
    private _isGlowing:boolean;
    private _glowTween:TweenLite;

    constructor(keyword:string, onClickedCallback:() => void) {
        super({
            idle : GameResources.getTextures(`${keyword}Button`),
            over : GameResources.getTextures(`${keyword}Button`)[0],
            down : GameResources.getTextures(`${keyword}Button`),
            disabled : GameResources.getTextures(`${keyword}Button`)[0],
        }, onClickedCallback, 15);
        this._keyword = keyword;
    }

    protected init():void {
        super.init();

        this._shootOut = new PIXI.Sprite(GameResources.getTextures("shootOutText")[0]);
        this._shootOut.anchor.set(0.5);
        this._shootOut.scale.set(0.28);
        this._shootOut.rotation = -0.27;
        this._shootOut.position.set(-100, 70);
        this.addChild(this._shootOut);

        this._particleContainer = new PIXI.Container();
        this._particleContainer.position.set(0, 240);
        this.addChild(this._particleContainer);

        this.interactiveChildren = false;
        this.hitArea = new PIXI.Rectangle(-190, -240, 380, 480);
    }

    public setState(state:ButtonState, autoPlay?:boolean):void {
        super.setState(state, autoPlay);

        this.stopIdleGlow();
        this.stopFloat();
        this.stopEmitter();

        switch(state) {
            case ButtonState.idle:
                this.floatMe();
                this.playIdleGlow(false);
                this.playIdleEmitter();
                break;
            case ButtonState.over:
                this.playIdleGlow(false);
                this.playOverEmitter();
                break;
            case ButtonState.down:
                this.playIdleGlow(false);
                break;
            case ButtonState.disabled:
                this.stopAll();
                break;
            default:
            // do nothing.
        }
    }

    public playUnselectedTint(featureText:PIXI.Text):TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(TweenLite.to(this._disabledState, 0.2, {pixi : {tint : 0x555555}}));
        if(this._shootOut.visible) {
            timeline.add(TweenLite.to(this._shootOut, 0.2, {pixi : {tint : 0x555555}}), 0);
        }
        if(this._fsNumber.visible) {
            timeline.add(TweenLite.to(this._fsNumber, 0.2, {pixi : {tint : 0x555555}}), 0);
        }
        timeline.add(TweenLite.to(featureText, 0.2, {pixi : {tint : 0x555555}}), 0);
        return timeline;
    }

    public resetUnselectedTint(featureText:PIXI.Text):void {
        this._disabledState.tint = 0xffffff;
        this._shootOut.tint = 0xffffff;
        this._fsNumber.tint = 0xffffff;
        featureText.tint = 0xffffff;
    }

    public setFSNumber(fsLeft:number, visible:boolean):void {
        if(!this._fsNumber) {
            this._fsNumber = new PIXI.BitmapText("", this._numberTextStyle);
            (<PIXI.Point>this._fsNumber.anchor).set(0.5, 0.5);
            this._fsNumber.position.set(0, 63);
            this.addChild(this._fsNumber);
        }
        this._fsNumber.text = this.getDisplayNumber(fsLeft);
        this._fsNumber.visible = visible;
    }

    private getDisplayNumber(number:number):string {
        return `${number}`;
    }

    public setShootOut(visible:boolean):void {
        this._shootOut.visible = visible;
    }

    public floatMe():void {
        this._isFloating = true;
        this.loopFloat();
    }

    private loopFloat():void {
        if(!this._isFloating) {
            return;
        }

        CustomWiggle.create("floatWiggle", {wiggles : 15, type : "random"});
        // const random:number = (Math.random() * 2 + 8) * 0.001; // 0.008--0.010
        this._floatTween = TweenLite.to(this.scale, 20, {
            x : `+=0.01`,
            y : `+=0.01`,
            ease : "floatWiggle",
            onComplete : () => this.loopFloat()
        });
    }

    public stopFloat():void {
        this._isFloating = false;
        if(this._floatTween && this._floatTween.isActive()) {
            this._floatTween.progress(1);
        }
    }

    public initGlow():void {
        this._glows = [this.createGlow(), this.createGlow()];
        this.playIdleGlow(false);
    }

    private createGlow():PIXI.Sprite {
        const glow:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(`${this._keyword}Glow`)[0]);
        glow.blendMode = PIXI.BLEND_MODES.ADD;
        glow.interactive = false;
        glow.anchor.set(0.5);
        glow.scale.set(2.8);
        glow.alpha = 0;
        this.addChild(glow);
        return glow;
    }

    public playIdleGlow(selected:boolean):void {
        if(!this._glows) {
            return;
        }

        if(!this._isGlowing) {
            this._isGlowing = true;
            TweenLite.to(this._glows[1], 0.2, {alpha : 1, onComplete : () => this.loopGlow()});
        }

        if(selected) {
            TweenLite.to(this._glows[0], 0.2, {alpha : 1});
        }
    }

    private loopGlow():void {
        if(!this._isGlowing) {
            return;
        }

        CustomWiggle.create("buttonGlowWiggle", {wiggles : 20, type : "random"});
        this._glowTween = TweenLite.fromTo(this._glows[1], 1.5,
            {alpha : 1},
            {
                alpha : 0.8, ease : "floatWiggle",
                onComplete : () => this.loopGlow()
            });
    }

    private playClickGlow():void {
        this.stopIdleGlow();
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TweenLite.to(this._glows[0], 0.06, {alpha : 1}),
            TweenLite.to(this._glows[1], 0.06, {alpha : 1})
        ], 0);
        timeline.add([
            TweenLite.fromTo(this._glows[0].scale, 0.2, {x : 2.4, y : 2.4}, {x : 3.2, y : 3.2}),
            TweenLite.fromTo(this._glows[1].scale, 0.2, {x : 2.4, y : 2.4}, {x : 3.2, y : 3.2})
        ], 0);
        timeline.add([
            TweenLite.to(this._glows[0].scale, 0.01, {x : 2.8, y : 2.8}),
            TweenLite.to(this._glows[1].scale, 0.01, {x : 2.8, y : 2.8})
        ]);
    }

    public stopIdleGlow():void {
        this._isGlowing = false;
        if(this._glows) {
            if(this._glowTween && this._glowTween.isActive()) {
                this._glowTween.progress(1);
            }
            TweenLite.to(this._glows[1], 0.2, {alpha : 0});
        }
    }

    public playIdleEmitter():void {
        if(!this._particleContainer) {
            return;
        }
        if(!this._idleEmitter) {
            this._idleEmitter = new Emitter(this._particleContainer, GameResources.getTextures("fsintroParticle"), this._idleConfig);
            ParticlesManager.addEmitter(this._idleEmitter);
        }
        this._isIdleEmitting = true;
        this.loopEmit();
    }

    private loopEmit():void {
        if(!this._isIdleEmitting) {
            return;
        }

        this._idleEmitter.emit = true;
        TweenLite.to(this, 1 + Math.random() * 2, {onComplete : () => this.loopEmit()});
    }

    private playOverEmitter():void {
        if(!this._particleContainer) {
            return;
        }

        if(!this._overEmitter) {
            this._overEmitter = new Emitter(this._particleContainer, GameResources.getTextures("fsintroParticle"), this._overConfig);
            ParticlesManager.addEmitter(this._overEmitter);
        }
        this._overEmitter.emit = true;
    }

    public playClickEmitter():void {
        if(!this._particleContainer) {
            return;
        }

        if(!this._clickEmitter) {
            this._clickEmitter = new Emitter(this._particleContainer, GameResources.getTextures("fsintroParticle"), this._clickConfig);
            ParticlesManager.addEmitter(this._clickEmitter);
        }
        this._clickEmitter.emit = true;
    }

    private stopEmitter():void {
        if(this._idleEmitter) {
            this._idleEmitter.emit = false;
        }
        this._isIdleEmitting = false;

        if(this._overEmitter) {
            this._overEmitter.emit = false;
        }
    }

    public playClick():void {
        this.playClickGlow();
        this.playClickEmitter();
    }

    private stopAll():void {
        this.stopFloat();
        this.stopEmitter();
        if(this._clickEmitter) {
            this._clickEmitter.emit = false;
        }

        if(this._glows) {
            this.stopIdleGlow();
            TweenLite.to(this._glows[0], 0.1, {alpha : 0});
            TweenLite.to(this._glows[1], 0.1, {alpha : 0});
            this._glows[0].scale.set(2.8);
            this._glows[1].scale.set(2.8);
        }
    }
}